import round from "../number/round";

export const lbsTokg = (weight: number, precision = 1) => {
  return round(weight * 0.45359237, precision) ?? weight * 0.45359237;
};
